module.exports = __webpack_public_path__ + "img/Schedule-Messages-on-WhatsApp.c84e1ad2.webp";